export const encodeEmail = (originalString: string): string =>
  encodeURIComponent(originalString);

export const decodeEmail = (encodedString: string): string =>
  decodeURIComponent(encodedString);
